<script>
export default {
  name: 'popArea',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemObj: {
      type: Object,
      default: {}
    },
    areaList: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      showPopup: this.value,
    }
  },
  watch:{
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    onCancel(){
      this.showPopup = false;
    },
    onConfirm(values){
      let val = '';
      values.map((v)=>{
        val += v.name+'/';
      });
      this.itemObj.value = val.substring(0,val.length-1);
      this.$emit('submit', values);
      this.onCancel();
    }
  }
}
</script>
<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
  >
    <van-area :area-list="areaList" @confirm="onConfirm" @cancel="onCancel" />
<!--    <van-picker-->
<!--        v-if="itemObj.params&&itemObj.params.customDesign"-->
<!--        show-toolbar-->
<!--        :title="itemObj.name"-->
<!--        :columns="itemObj.params.customDesign.values"-->
<!--        value-key="label"-->
<!--        @confirm="onConfirm"-->
<!--        @cancel="onCancel"-->
<!--    />-->
  </van-popup>
</template>
<style scoped lang="scss">
</style>